import AccountsCardsPage from './AccountsCardsPage';

export default AccountsCardsPage;
